export default __webpack_public_path__ + "static/media/verifica.cbc1a6e3.png";